import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { AuthService } from './core/services/auth.service';
import { LookupService } from './core/services/lookup.service';
import { SettingsService } from './core/services/settings.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiInterceptor, authInterceptor])),
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      const settings = inject(SettingsService);
      const lookups = inject(LookupService);

      return auth.initialize().then(async () => {
        if (!auth.isAuthenticated()) {
          return;
        }

        try {
          await firstValueFrom(settings.load());
        } catch {
          settings.applyDefaults();
        }

        try {
          await firstValueFrom(
            lookups.preload(['lead_source', 'lead_status', 'ticket_priority', 'ticket_status']),
          );
        } catch {
          // Non-fatal — lookups will be fetched on demand
        }
      });
    }),
  ],
};
